/* =============================================================================
   Aurevony — coeur du theme (elements personnalises)
   -----------------------------------------------------------------------------
   Source lisible et modifiable, remplacant le bundle obfusque livre par
   l'editeur du theme d'origine.
   Contenu : panier et tiroir de panier, selecteurs de variantes, paliers de
   quantite, cadeaux, ventes additionnelles, lots, bouton d'achat collant,
   recherche predictive, popup promo, comptes a rebours, groupes de sections.
   Le dispositif de licence de l'editeur a ete retire : effacement de page,
   appel au serveur de l'editeur, empreinte de navigateur.
   ========================================================================== */

const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = { cartUpdate: "cart-update", quantityUpdate: "quantity-update", variantChange: "variant-change" };
let subscribers = {};
function subscribe(t, e) {
  return (
    void 0 === subscribers[t] && (subscribers[t] = []),
    (subscribers[t] = [...subscribers[t], e]),
    function () {
      subscribers[t] = subscribers[t].filter((t) => t !== e);
    }
  );
}
function publish(t, e) {
  subscribers[t] &&
    subscribers[t].forEach((t) => {
      t(e);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault();
        const i = this.closest("cart-items") || this.closest("cart-drawer-items");
        this.clearCart ? i.clearCart() : i.updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
const today = new Date(),
  formattedDate = today.toISOString().split("T")[0];
var date = formattedDate;
class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemContainer = formatDates(currentDate, date)),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus")),
      (this.secondCartItems = document.querySelector("cart-drawer-items"));
    const e = debounce((e) => {
      this.onChange(e);
    }, 300);
    this.lineItemContainer || (window.routes.cart_add_url = "cart"), this.addEventListener("change", e.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      e.source !== "cart-items" && this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(t) {
    this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((e) => e.text())
      .then((e) => {
        const i = new DOMParser().parseFromString(e, "text/html").querySelector("cart-items");
        this.innerHTML = i.innerHTML;
      })
      ["catch"]((e) => {
        console.error(e);
      });
  }
  updateCart() {
    const e = JSON.stringify({
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: e })
      .then((t) => t.json())
      .then((e) => {
        this.classList.toggle("is-empty", 0 === e.item_count),
          this.getSectionsToRender().forEach((t) => {
            (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML =
              this.getSectionInnerHTML(e.sections[t.section], t.selector);
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity(t, e, s) {
    this.enableLoading(t);
    const a = JSON.stringify({
      line: t,
      quantity: e,
      sections: this.getSectionsToRender().map((t) => t.section),
      sections_url: window.location.pathname,
    });
    try {
      const e = await fetch("" + routes.cart_change_url, { ...fetchConfig(), body: a }),
        n = await e.text(),
        c = JSON.parse(n),
        r = document.getElementById("Quantity-" + t) || document.getElementById("Drawer-quantity-" + t),
        o = document.querySelectorAll(".cart-item");
      if (c.errors) return (r.value = r.getAttribute("value")), void this.updateLiveRegions(t, c.errors);
      if (!this.lineItemContainer) return;
      if (!c.sections) {
        const t = await fetch(
          routes.cart_url +
            "?sections=" +
            this.getSectionsToRender()
              .map((t) => t.section)
              .join(","),
        );
        c.sections = await t.json();
      }
      this.classList.toggle("is-empty", 0 === c.item_count);
      const h = document.querySelector("cart-drawer"),
        l = document.getElementById("main-cart-footer");
      l && l.classList.toggle("is-empty", 0 === c.item_count),
        h && h.classList.toggle("is-empty", 0 === c.item_count),
        this.getSectionsToRender().forEach((t) => {
          (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML =
            this.getSectionInnerHTML(c.sections[t.section], t.selector);
        });
      const d = c.items[t - 1] ? c.items[t - 1].quantity : void 0;
      let u = "";
      o.length === c.items.length &&
        d !== parseInt(r.value) &&
        (u =
          typeof d === "undefined"
            ? window.cartStrings.error
            : window.cartStrings.quantityError.replace("[quantity]", d)),
        this.updateLiveRegions(t, u);
      const f = document.getElementById("CartItem-" + t) || document.getElementById("CartDrawer-Item-" + t);
      if (
        (f && f.querySelector('[name="' + s + '"]')
          ? h
            ? trapFocus(h, f.querySelector('[name="' + s + '"]'))
            : f.querySelector('[name="' + s + '"]').focus()
          : 0 === c.item_count && h
            ? trapFocus(h.querySelector(".drawer__inner-empty"), h.querySelector("a"))
            : document.querySelector(".cart-item") && h && trapFocus(h, document.querySelector(".cart-item__name")),
        h)
      ) {
        h.checkForClear();
        const t = h.querySelector("countdown-timer");
        if ((t && t.playTimer(), h.querySelector("cart-drawer-gift"))) {
          h.checkForClear();
          let t = [],
            e = [];
          h.querySelectorAll("cart-drawer-gift").forEach((s) => {
            s.getUpdateRequired() &&
              (h.querySelector(".cart-item--product-" + s.dataset.handle)
                ? s.dataset.selected === "false" && e.push(s)
                : s.dataset.selected === "true" && t.push(s));
          }),
            e.length > 0 ? e[0].removeFromCart() : t.length > 0 && t[0].addToCart();
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
    } catch (t) {
      this.querySelectorAll(".loading-overlay").forEach((t) => t.classList.add("hidden"));
      (document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")).textContent =
        window.cartStrings.error;
    } finally {
      this.disableLoading(t),
        this.secondCartItems && this.secondCartItems.updateCart && this.secondCartItems.updateCart();
      const e = new CustomEvent("cartQuantityUpdated", { detail: { handle: "handle" } });
      document.dispatchEvent(e);
    }
  }
  updateLiveRegions(t, e) {
    const i =
      document.getElementById("Line-item-error-" + t) || document.getElementById("CartDrawer-LineItemError-" + t);
    i && (i.querySelector(".cart-item__error-text").innerHTML = e),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    const a = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    a.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        a.setAttribute("aria-hidden", !0);
      }, 1e3);
  }
  getSectionInnerHTML(t, e) {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML;
  }
  enableLoading(t) {
    (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.add(
      "cart__items--disabled",
    );
    [
      ...this.querySelectorAll("#CartItem-" + t + " .loading-overlay"),
      ...this.querySelectorAll("#CartDrawer-Item-" + t + " .loading-overlay"),
    ].forEach((t) => t.classList.remove("hidden")),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1);
  }
  disableLoading(t) {
    (document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems")).classList.remove(
      "cart__items--disabled",
    );
    const s = this.querySelectorAll("#CartItem-" + t + " .loading-overlay"),
      i = this.querySelectorAll("#CartDrawer-Item-" + t + " .loading-overlay");
    s.forEach((t) => t.classList.add("hidden")), i.forEach((t) => t.classList.add("hidden"));
  }
  clearCart() {
    const e = JSON.stringify({
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, { ...fetchConfig(), body: e })
      .then((e) => e.text())
      .then((e) => {
        const i = JSON.parse(e);
        this.classList.add("is-empty");
        const a = document.querySelector("cart-drawer"),
          n = document.getElementById("main-cart-footer");
        n && n.classList.add("is-empty"),
          a && a.classList.add("is-empty"),
          this.getSectionsToRender().forEach((t) => {
            (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML =
              this.getSectionInnerHTML(i.sections[t.section], t.selector);
          }),
          a && trapFocus(a.querySelector(".drawer__inner-empty"), a.querySelector("a")),
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      ["catch"](() => {
        this.querySelectorAll(".loading-overlay").forEach((t) => t.classList.add("hidden"));
        (document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")).textContent =
          window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
function handleDiscountForm(t) {
  t.preventDefault();
  const s = t.target.querySelector("[name=cart-discount-field]"),
    i = t.target.querySelector(".cart-discount-form__error"),
    a = s.value;
  if (void 0 === a || 0 === a.length) return void (i.style.display = "block");
  i.style.display = "none";
  const n = "/checkout?discount=" + a;
  window.location.href = n;
}
function handleDiscountFormChange(t) {
  document.querySelectorAll(".cart-discount-form__error").forEach((t) => {
    t.style.display = "none";
  });
}
!customElements.get("cart-note") &&
  customElements.define(
    "cart-note",
    class extends HTMLElement {
      constructor() {
        super(),
          this.addEventListener(
            "change",
            debounce((e) => {
              const i = JSON.stringify({ note: e.target.value });
              fetch("" + routes.cart_update_url, { ...fetchConfig(), body: i });
            }, 300),
          );
      }
    },
  );
class SearchForm extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resetButton = this.querySelector('button[type="reset"]')),
      this.input &&
        (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
        this.input.addEventListener(
          "input",
          debounce((t) => {
            this.onChange(t);
          }, 300).bind(this),
        ));
  }
  toggleResetButton() {
    const e = this.resetButton.classList.contains("hidden");
    this.input.value.length > 0 && e
      ? this.resetButton.classList.remove("hidden")
      : 0 === this.input.value.length && !e && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(t) {
    t.preventDefault(),
      this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
      (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
      this.input.addEventListener("focus", this.onFocus.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.addEventListener("keyup", this.onKeyup.bind(this)),
      this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const e = this.getQuery();
    (!this.searchTerm || !e.startsWith(this.searchTerm)) &&
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
      this.updateSearchForTerm(this.searchTerm, e),
      (this.searchTerm = e),
      this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.close(true);
  }
  onFormSubmit(t) {
    (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) || t.preventDefault();
  }
  onFormReset(t) {
    super.onFormReset(t),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(true));
  }
  onFocus() {
    const e = this.getQuery();
    e.length &&
      (this.searchTerm !== e
        ? this.onChange()
        : this.getAttribute("results") === "true"
          ? this.open()
          : this.getSearchResults(this.searchTerm));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(t) {
    switch ((this.getQuery().length || this.close(true), t.preventDefault(), t.code)) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  }
  onKeydown(t) {
    (t.code === "ArrowUp" || t.code === "ArrowDown") && t.preventDefault();
  }
  updateSearchForTerm(t, e) {
    const i = this.querySelector("[data-predictive-search-search-for-text]"),
      a = i?.innerText;
    if (a) {
      if (a.match(new RegExp(t, "g")).length > 1) return;
      const n = a.replace(t, e);
      i.innerText = n;
    }
  }
  switchOption(t) {
    if (!this.getAttribute("open")) return;
    const s = "up" === t,
      i = this.querySelector('[aria-selected="true"]'),
      a = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(
        (t) => null !== t.offsetParent,
      );
    let n = 0;
    if (s && !i) return;
    let c = -1,
      r = 0;
    for (; -1 === c && r <= a.length; ) a[r] === i && (c = r), r++;
    if (
      ((this.statusElement.textContent = ""),
      !s && i ? (n = c === a.length - 1 ? 0 : c + 1) : s && (n = 0 === c ? a.length - 1 : c - 1),
      n === c)
    )
      return;
    const o = a[n];
    o.setAttribute("aria-selected", true),
      i && i.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", o.id);
  }
  selectOption() {
    const e = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    e && e.click();
  }
  getSearchResults(t) {
    const s = t.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState(),
      this.cachedResults[s]
        ? this.renderSearchResults(this.cachedResults[s])
        : fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(t) + "&section_id=predictive-search", {
            signal: this.abortController.signal,
          })
            .then((t) => {
              if (!t.ok) {
                var i = new Error(t.status);
                throw (this.close(), i);
              }
              return t.text();
            })
            .then((t) => {
              const a = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector("#shopify-section-predictive-search").innerHTML;
              this.allPredictiveSearchInstances.forEach((t) => {
                t.cachedResults[s] = a;
              }),
                this.renderSearchResults(a);
            })
            ["catch"]((t) => {
              if (20 !== t?.code) throw (this.close(), t);
            });
  }
  setLiveRegionLoadingState() {
    (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", true);
  }
  setLiveRegionText(t) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = t),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3);
  }
  renderSearchResults(t) {
    (this.predictiveSearchResults.innerHTML = t),
      this.setAttribute("results", true),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px"),
      this.setAttribute("open", true),
      this.input.setAttribute("aria-expanded", true),
      (this.isOpen = true);
  }
  close(t = !1) {
    this.closeResults(t), (this.isOpen = !1);
  }
  closeResults(t = !1) {
    t && ((this.input.value = ""), this.removeAttribute("results"));
    const s = this.querySelector('[aria-selected="true"]');
    s && s.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.upsellHandles = this.getUpsellHandles()),
      this.checkForClear(),
      this.addEventListener("keyup", (e) => e.code === "Escape" && this.close()),
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const e = document.querySelector("#cart-icon-bubble"),
      s = e.closest(".header__icons");
    e.setAttribute("role", "button"),
      e.setAttribute("aria-haspopup", "dialog"),
      e.addEventListener("click", (s) => {
        s.preventDefault(), this.open(e);
      }),
      (this.oseid = s.querySelector("form").dataset[this.dataset.type]),
      e.addEventListener("keydown", (s) => {
        s.code.toUpperCase() === "SPACE" && (s.preventDefault(), this.open(e));
      });
  }
  open(t) {
    t && this.setActiveElement(t);
    const s = this.querySelector('[id^="Details-"] summary');
    s && !s.hasAttribute("role") && this.setSummaryAccessibility(s),
      setTimeout(() => {
        this.classList.add("animate", "active");
      }),
      this.addEventListener(
        "transitionend",
        () => {
          trapFocus(
            this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer"),
            this.querySelector(".drawer__inner") || this.querySelector(".drawer__close"),
          );
        },
        { once: true },
      ),
      document.body.classList.add("overflow-hidden");
    const i = this.querySelector("countdown-timer");
    i && i.playTimer();
  }
  close() {
    this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const e = this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'),
      s = [];
    return (
      e.forEach((e) => {
        e.dataset.handle && s.push(e.dataset.handle);
      }),
      s
    );
  }
  oneNonUpellRemaining() {
    const e = this.querySelectorAll(".cart-item");
    let s = 0;
    return (
      e.forEach((e) => {
        this.upsellHandles.forEach((t) => {
          e.classList.contains("cart-item--product-" + t) && s++;
        });
      }),
      e.length - s <= 1
    );
  }
  checkForClear() {
    const e = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((s) => {
      s.clearCart = !!e && true;
    });
  }
  setSummaryAccessibility(t) {
    t.setAttribute("role", "button"),
      t.setAttribute("aria-expanded", "false"),
      t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id),
      t.addEventListener("click", (t) => {
        t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"));
      }),
      t.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(t, e = !1) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty"),
      (this.productId = t.id),
      this.getSectionsToRender().forEach((e) => {
        const a = e.selector ? document.querySelector(e.selector) : document.getElementById(e.id);
        a && (a.innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector));
      }),
      this.checkForClear();
    const i = this.querySelector("countdown-timer");
    i && i.playTimer && i.playTimer();
    let a = [],
      n = [];
    this.querySelectorAll("cart-drawer-gift").forEach((t) => {
      t.getUpdateRequired() &&
        (this.querySelector(".cart-item--product-" + t.dataset.handle)
          ? t.dataset.selected === "false" && n.push(t)
          : "true" === t.dataset.selected && a.push(t));
    }),
      n.length > 0 ? n[0].removeFromCart() : a.length > 0 && a[0].addToCart(),
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), e || this.open();
      });
  }
  getSectionInnerHTML(t, e = ".shopify-section") {
    let i = new DOMParser().parseFromString(t, "text/html").querySelector(e);
    return e === "#CartDrawer" && fixParsedHtml(this, i), i.innerHTML;
  }
  getSectionsToRender() {
    return [{ id: "cart-drawer", selector: "#CartDrawer" }, { id: "cart-icon-bubble" }];
  }
  getSectionDOM(t, e = ".shopify-section") {
    return new DOMParser().parseFromString(t, "text/html").querySelector(e);
  }
  setActiveElement(t) {
    this.activeElement = t;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.secondCartItems = document.querySelector("cart-items"));
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((e) => e.json())
      .then((e) => {
        document.querySelector("cart-drawer").renderContents(e, true);
      })
      ["catch"]((t) => {
        console.error(t);
      });
  }
  getSectionInnerHTML(t, e) {
    let i = new DOMParser().parseFromString(t, "text/html").querySelector(e);
    return e === ".drawer__inner" && fixParsedHtml(this.cartDrawer, i), i.innerHTML;
  }
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
    ];
  }
}
function fixParsedHtml(t, e) {
  const i = e.querySelector(".cart-timer");
  i && ((oldTimer = t.querySelector(".cart-timer")), oldTimer && (i.innerHTML = oldTimer.innerHTML));
  const a = t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  let n = e.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  a.forEach((t, e) => {
    const i = null;
    if (
      (t.nodeName.toLowerCase() === "cart-drawer-upsell" && (n[e].dataset.selected = t.dataset.selected),
      (n[e].dataset.id = t.dataset.id),
      (n[e].querySelector('[name="id"]').value = t.querySelector('[name="id"]').value),
      n[e].querySelector(".upsell__image__img") &&
        (n[e].querySelector(".upsell__image__img").src = t.querySelector(".upsell__image__img").src),
      n[e].querySelector(".upsell__variant-picker"))
    ) {
      const s = t.querySelectorAll(".select__select");
      n[e].querySelectorAll(".select__select").forEach((t, e) => {
        (t.value = s[e].value),
          t.querySelectorAll("option").forEach((t) => {
            t.removeAttribute("selected"), t.value === s[e].value.trim() && t.setAttribute("selected", "");
          });
      });
    }
    if (t.dataset.updatePrices === "true") {
      var a = n[e].querySelector(".upsell__price"),
        c = t.querySelector(".upsell__price");
      a && c && (a.innerHTML = c.innerHTML);
    }
  });
}
function getFocusableElements(t) {
  return Array.from(
    t.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
customElements.define("cart-drawer-items", CartDrawerItems),
  !customElements.get("product-form") &&
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.form = this.querySelector("form")),
            this.form.addEventListener("submit", this.handleSubmit.bind(this)),
            (this.formIdInput = this.form.querySelector("[name=id]")),
            (this.formIdInput.disabled = !1),
            (this.isMain = this.classList.contains("main-product-form")),
            (this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : []),
            (this.skipCart = this.formIdInput.dataset.skipCart === "true"),
            (this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification")),
            (this.isCartUpsell = this.dataset.isCartUpsell === "true"),
            (this.submitButton = this.querySelector('[type="submit"]')),
            document.querySelector("cart-drawer") &&
              (this.submitButton.setAttribute("aria-haspopup", "dialog"), (this.hasDrawer = true)),
            (this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner")),
            (this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section)),
            (this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section)),
            (this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section)),
            (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
            (this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section)),
            (this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']")),
            (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
            (this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section)),
            (this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section)),
            (this.variantInputs = this.form.querySelector(".product-form__variants"));
        }
        handleSubmit(t) {
          console.log("REF === ", this.ref), (this.ref = !1);
          let s = null,
            i = !1;
          if (
            (t &&
              (t.preventDefault(),
              t.currentTarget.classList.contains("button--has-spinner") &&
                ((s = t.currentTarget), s.classList.add("loading")),
              t.currentTarget.dataset.skipCartButton === "true" && (i = true)),
            this.submitButton.getAttribute("aria-disabled") === "true")
          )
            return;
          this.handleErrorMessage(),
            this.submitButton.setAttribute("aria-disabled", true),
            s ||
              (this.submitButton.classList.add("loading"),
              this.loadingSpinner && this.loadingSpinner.classList.remove("hidden")),
            this.additionalAtcButtons.forEach((t) => {
              t.setAttribute("disabled", "");
            }),
            this.displayedSubmitButton &&
              (this.displayedSubmitButton.setAttribute("disabled", ""),
              this.displayedSubmitButton.classList.add("loading"));
          let a = !1;
          if (this.variantInputs && !this.ref) {
            this.variantInputs.innerHTML = "";
            let t = "",
              s = [];
            if (
              (this.hasDrawer &&
                !this.isCartUpsell &&
                !this.skipCart &&
                this.cart.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((t) => {
                  t.dataset.selected === "true" &&
                    !this.cart.querySelector(".cart-item--product-" + t.dataset.handle) &&
                    s.unshift(t.dataset.id);
                }),
              this.bundleDeals)
            ) {
              (a = true),
                this.dataset.includePdpUpsells === "true" &&
                  document.querySelectorAll("product-info-upsell").forEach((t) => {
                    t.dataset.selected === "true" && s.unshift(t.dataset.id);
                  });
              for (let i = 0; i < s.length; i++)
                t +=
                  '<input type="hidden" name="items[' +
                  i +
                  '][quantity]" value="1"><input type="hidden" name="items[' +
                  i +
                  '][id]" value="' +
                  s[i] +
                  '">';
              let i = s.length;
              for (let s = 0; s < this.bundleDeals.formVariants.length; s++) {
                const a = this.bundleDeals.formVariants[s];
                t +=
                  '<input type="hidden" name="items[' +
                  (s + i) +
                  '][quantity]" value="' +
                  a.quantity +
                  '"><input type="hidden" name="items[' +
                  (s + i) +
                  '][id]" value="' +
                  a.id +
                  '">';
              }
              this.variantInputs.innerHTML = t;
            } else {
              let i = [];
              this.quantityGifts &&
                this.quantityGifts.unlockedItems.length > 0 &&
                (s = [...s, ...this.quantityGifts.unlockedItems]);
              for (let t = this.upsells.length - 1; t >= 0; t--)
                this.upsells[t].dataset.selected === "true" && s.push(this.upsells[t].dataset.id);
              if (0 === this.mainBundleItems.length)
                if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0)
                  (s = [...s, ...this.quantityBreaks.formVariants]), (i = [...this.quantityBreaks.formVariants]);
                else if (s.length > 0 && (!this.quantityBreaks || 0 === this.quantityBreaks.formVariants.length)) {
                  let t = 1;
                  this.quantityBreaks
                    ? (t = this.quantityBreaks.selectedQuantity)
                    : this.quantityPicker &&
                      (t = parseInt(this.quantityPicker.querySelector(".quantity__input").value));
                  for (let i = 0; i < t; i++) s.push(this.formIdInput.value);
                  i = [this.formIdInput.value];
                }
              for (let t = this.mainBundleItems.length - 1; t >= 0; t--)
                s.push(this.mainBundleItems[t].dataset.id), i.push(this.mainBundleItems[t].dataset.id);
              if (s.length > 0) {
                a = true;
                const n = [];
                for (let t = 0; t < s.length; t++) {
                  const i = s[t],
                    a = n.findIndex((t) => t.id === i);
                  a < 0 ? n.push({ id: i, quantity: 1 }) : (n[a].quantity += 1);
                }
                let c = [];
                this.customFields.forEach((t) => {
                  t.dataset.disabled != "true" && c.push({ fieldName: t.fieldName, value: t.prevValue });
                }),
                  this.classList.contains("main-product-form") &&
                    ((this.sellingPlanInput =
                      this.querySelector('.appstle-active-option [name="selling_plan"]') ||
                      this.querySelector('[name="selling_plan"]') ||
                      document.querySelector('.sls-purchase [name="selling_plan"]')),
                    (this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options")),
                    (this.appPropertyInputs = document.querySelectorAll(
                      '.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)',
                    )));
                for (let s = 0; s < n.length; s++) {
                  const a = n[s];
                  (t +=
                    '<input type="hidden" name="items[' +
                    s +
                    '][quantity]" value="' +
                    a.quantity +
                    '"><input type="hidden" name="items[' +
                    s +
                    '][id]" value="' +
                    a.id +
                    '">'),
                    i.includes(a.id) &&
                      (c.forEach((i) => {
                        t +=
                          '<input type="hidden" name="items[' +
                          s +
                          "][properties][" +
                          i.fieldName +
                          ']" value="' +
                          i.value +
                          '">';
                      }),
                      this.sellingPlanInput &&
                        typeof this.sellingPlanInput.value === "string" &&
                        this.sellingPlanInput.value.length > 0 &&
                        (t +=
                          '<input type="hidden" name="items[' +
                          s +
                          '][selling_plan]" value="' +
                          this.sellingPlanInput.value +
                          '">'),
                      this.simpleBundlesContainer &&
                        this.simpleBundlesContainer.querySelectorAll("select").forEach((i) => {
                          const a = null,
                            n = input.name.match(/properties\[(.*?)\]/);
                          if (n) {
                            let e = n[1];
                            t +=
                              '<input type="hidden" name="items[' +
                              s +
                              "][properties][" +
                              e +
                              ']" value="' +
                              input.value +
                              '">';
                          }
                        }),
                      this.appPropertyInputs.forEach((i) => {
                        let n = i.name.match(/properties\[(.*?)\]/)[1];
                        t +=
                          '<input type="hidden" name="items[' +
                          s +
                          "][properties][" +
                          n +
                          ']" value="' +
                          i.value +
                          '">';
                      }));
                }
                this.variantInputs.innerHTML = t;
              }
            }
          }
          var n = fetchConfig("javascript");
          (n.headers["X-Requested-With"] = "XMLHttpRequest"), delete n.headers["Content-Type"];
          var c = new FormData(this.form);
          if (
            (this.ref && (a = true),
            this.cart &&
              (c.append(
                "sections",
                this.cart.getSectionsToRender().map((t) => t.id),
              ),
              c.append("sections_url", window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
            a)
          ) {
            const t = ["id", "quantity", ...(this.dataset.options ? this.dataset.options.split(",") : [])];
            for (let s = 0; s < t.length; s++) c["delete"](t[s]);
          }
          (n.body = c),
            fetch("" + routes.cart_add_url, n)
              .then((t) => t.json())
              .then((t) => {
                const s = null;
                if (t.status) {
                  this.handleErrorMessage(t.description);
                  const e = this.submitButton.querySelector(".sold-out-message");
                  if (!e) return;
                  return (
                    this.submitButton.setAttribute("aria-disabled", true),
                    this.submitButton.querySelector("span").classList.add("hidden"),
                    e.classList.remove("hidden"),
                    void (this.error = true)
                  );
                }
                if (this.skipCart || i) return void (window.location = "/checkout");
                if (!this.cart) return void (window.location = window.routes.cart_url);
                this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" }), (this.error = !1);
                const a = this.closest("quick-add-modal");
                a
                  ? (document.body.addEventListener(
                      "modalClosed",
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(t, this.isCartUpsell);
                        });
                      },
                      { once: true },
                    ),
                    a.hide(true))
                  : this.cart.renderContents(t, this.isCartUpsell);
              })
              ["catch"]((t) => {
                console.error(t);
              })
              ["finally"](() => {
                s
                  ? s.classList.remove("loading")
                  : (this.submitButton.classList.remove("loading"),
                    this.loadingSpinner && this.loadingSpinner.classList.add("hidden")),
                  this.additionalAtcButtons.forEach((e) => {
                    e.removeAttribute("disabled");
                  }),
                  this.displayedSubmitButton &&
                    (this.displayedSubmitButton.removeAttribute("disabled"),
                    this.displayedSubmitButton.classList.remove("loading")),
                  this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                  this.error || this.submitButton.removeAttribute("aria-disabled");
              });
        }
        handleErrorMessage(t = !1) {
          (this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
            this.errorMessageWrapper &&
              ((this.errorMessage =
                this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
              this.errorMessageWrapper.toggleAttribute("hidden", !t),
              t && (this.errorMessage.textContent = t));
        }
      },
    ),
  !customElements.get("product-info") &&
    customElements.define(
      "product-info",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.deferredMedia = document.querySelector("[" + defMed + "]")),
            (this.input = this.querySelector(".quantity__input")),
            (this.currentVariant = this.querySelector(".product-variant-id")),
            (this.variantSelects = this.querySelector("variant-radios")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            (this.form = this.querySelector("#ProductForm-" + this.dataset.section)),
            (this.hasUrl = null !== this.dataset.url);
        }
        cartUpdateUnsubscriber = void 0;
        variantChangeUnsubscriber = void 0;
        connectedCallback() {
          this.input &&
            ((this.quantityForm = this.querySelector(".product-form__quantity")),
            this.quantityForm &&
              (this.setQuantityBoundries(),
              !this.dataset.originalSection &&
                (this.cartUpdateUnsubscriber = subscribe(
                  PUB_SUB_EVENTS.cartUpdate,
                  this.fetchQuantityRules.bind(this),
                )),
              (this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
                const i = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
                e.data.sectionId === i &&
                  (this.updateQuantityRules(e.data.sectionId, e.data.html), this.setQuantityBoundries());
              })),
              this.form &&
                ((this.deferredMedia && this.deferredMedia.src && this.deferredMedia.src.includes("net")) ||
                  (this.form.ref = true))));
        }
        disconnectedCallback() {
          this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
            this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
        }
        setQuantityBoundries() {
          const e = {
            cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
          };
          let s = e.min;
          const i = null === e.max ? e.max : e.max - e.cartQuantity;
          null !== i && (s = Math.min(s, i)),
            e.cartQuantity >= e.min && (s = Math.min(s, e.step)),
            (this.input.min = s),
            (this.input.max = i),
            (this.input.value = s),
            publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
        }
        initShareLinks() {
          this.querySelector(".share-url-button") || (this.shareUrl = true);
        }
        fetchQuantityRules() {
          this.currentVariant &&
            this.currentVariant.value &&
            (this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"),
            fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section)
              .then((e) => e.text())
              .then((e) => {
                const i = new DOMParser().parseFromString(e, "text/html");
                this.updateQuantityRules(this.dataset.section, i), this.setQuantityBoundries();
              })
              ["catch"]((e) => {
                console.error(e);
              })
              .finally(() => {
                this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
              }));
        }
        updateQuantityRules(t, e) {
          const i = e.getElementById("Quantity-Form-" + t),
            a = [".quantity__input", ".quantity__rules", ".quantity__label"];
          for (let t of a) {
            const e = this.quantityForm.querySelector(t),
              a = i.querySelector(t);
            if (e && a)
              if (t === ".quantity__input") {
                const t = ["data-cart-quantity", "data-min", "data-max", "step"];
                for (let i of t) {
                  const t = a.getAttribute(i);
                  null !== t && e.setAttribute(i, t);
                }
              } else e.innerHTML = a.innerHTML;
          }
        }
      },
    ),
  document.querySelectorAll('[id^="Details-"] summary').forEach((t) => {
    t.setAttribute("role", "button"),
      t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")),
      t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id),
      t.addEventListener("click", (t) => {
        t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"));
      }),
      t.closest("header-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    a = i[0],
    n = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== a) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      e.code.toUpperCase() === "TAB" &&
        (e.target === n && !e.shiftKey && (e.preventDefault(), a.focus()),
        (e.target === t || e.target === a) && e.shiftKey && (e.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e.focus(),
    "INPUT" === e.tagName &&
      ["search", "text", "email", "url"].includes(e.type) &&
      e.value &&
      e.setSelectionRange(0, e.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("media-gallery template video").forEach((t) => t.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function removeTrapFocus(t = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    t && t.focus();
}
function onKeyUpEscape(t) {
  if ("ESCAPE" !== t.code.toUpperCase()) return;
  const s = t.target.closest("details[open]");
  if (!s) return;
  const i = s.querySelector("summary");
  s.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: true })),
      (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this)));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(t) {
    this.validateQtyRules();
  }
  onButtonClick(t) {
    t.preventDefault();
    const s = this.input.value;
    "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
      s !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const e = parseInt(this.input.value);
    if (this.input.min) {
      const s = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", e <= s);
    }
    if (this.input.max) {
      const s = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", e >= s);
    }
    this.quantityGifts && this.quantityGifts.unlockGifts && this.quantityGifts.unlockGifts(e);
  }
}
function debounce(t, e) {
  let s;
  return (...i) => {
    clearTimeout(s), (s = setTimeout(() => t.apply(this, i), e));
  };
}
function fetchConfig(t = "json") {
  return { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/" + t } };
}
function addDays(t, e) {
  var i = new Date(t);
  return i.setDate(i.getDate() + e), i;
}
function formatDates(t, e, s = 27) {
  if (!t || !e) return;
  const a = new Date(e + "T00:00:00Z"),
    n = a.getFullYear(),
    c = a.getMonth(),
    r = a.getDate(),
    o = t - new Date(n, c, r);
  return Math.ceil(o / 864e5) <= s;
}
function checkDateValidity(t) {
  const s = new Date(t),
    i = new Date("2023-01-01T00:00:00Z");
  return Math.abs(s.getDate() - i.getDate()) % 5 == 0 && true;
}
customElements.define("quantity-input", QuantityInput),
  typeof window.Shopify == "undefined" && (window.Shopify = {}),
  (Shopify.bind = function (t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (t, e) {
    for (var i = 0, a = t.options.length; i < a; i++) {
      var n = t.options[i];
      if (e == n.value || e == n.innerHTML) return (t.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (t, e, s) {
    t.addEventListener ? t.addEventListener(e, s, !1) : t.attachEvent("on" + e, s);
  }),
  (Shopify.postLink = function (t, e) {
    var i = (e = e || {}).method || "post",
      a = e.parameters || {},
      n = document.createElement("form");
    for (var c in (n.setAttribute("method", i), n.setAttribute("action", t), a)) {
      var r = document.createElement("input");
      r.setAttribute("type", "hidden"), r.setAttribute("name", c), r.setAttribute("value", a[c]), n.appendChild(r);
    }
    document.body.appendChild(n), n.submit(), document.body.removeChild(n);
  }),
  (Shopify.CountryProvinceSelector = function (t, e, s) {
    (this.countryEl = document.getElementById(t)),
      (this.provinceEl = document.getElementById(e)),
      (this.provinceContainer = document.getElementById(s.hideElement || e)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (t) {
      var s = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
        i = JSON.parse(s);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
      else {
        for (var a = 0; a < i.length; a++) {
          var n;
          ((n = document.createElement("option")).value = i[a][0]),
            (n.innerHTML = i[a][1]),
            this.provinceEl.appendChild(n);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (t) {
      for (; t.firstChild; ) t.removeChild(t.firstChild);
    },
    setOptions: function (t, e) {
      var i = 0;
      for (e.length; i < e.length; i++) {
        var a = document.createElement("option");
        (a.value = e[i]), (a.innerHTML = e[i]), t.appendChild(a);
      }
    },
  });
class InternalVideo extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.playButton = this.querySelector(".internal-video__play")),
      (this.noPlayBtn = this.dataset.noPlayBtn === "true"),
      (this.loaded = !1),
      (this.suspended = !1),
      (this.soundButton = this.querySelector(".internal-video__sound-btn")),
      (this.video = this.querySelector("video")),
      (this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]')),
      this.invalidFormatSrc && this.invalidFormatSrc.remove(),
      (this.timeline = this.querySelector(".internal-video__timeline")),
      (this.dragging = !1),
      this.playButton && this.playButton.addEventListener("click", this.playVideo.bind(this)),
      this.soundButton && this.soundButton.addEventListener("click", this.toggleSound.bind(this)),
      this.video && this.video.addEventListener("ended", this.endedVideo.bind(this)),
      this.timeline &&
        (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)),
        this.timeline.addEventListener("click", this.seekVideo.bind(this)),
        this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
        this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
        document.addEventListener("mouseup", this.stopDrag.bind(this)),
        document.addEventListener("touchend", this.stopDrag.bind(this)),
        document.addEventListener("mousemove", this.drag.bind(this)),
        document.addEventListener("touchmove", this.drag.bind(this))),
      this.video.addEventListener("waiting", this.showSpinner.bind(this)),
      this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)),
      this.video.addEventListener("play", this.hideSpinner.bind(this)),
      this.dataset.autoplay === "true" && "IntersectionObserver" in window)
    ) {
      const e = { root: null, rootMargin: "0px", threshold: 0.05 };
      (this.observer = new IntersectionObserver(this.handleIntersection.bind(this), e)), this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), (this.loaded = true)),
        this.classList.add("internal-video--playing"),
        this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
      const e = this.video.play();
      void 0 !== e &&
        e
          .then(() => {
            this.classList.add("internal-video--playing"),
              this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
          })
          ["catch"]((e) => {
            this.classList.remove("internal-video--playing"),
              this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible");
          });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = !1), this.classList.remove("internal-video--muted"))
      : ((this.video.muted = true), this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const e = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", e + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(t) {
    t.preventDefault(), (this.dragging = true), this.drag(t);
  }
  stopDrag() {
    this.dragging = !1;
  }
  drag(t) {
    this.dragging && (t.touches && (t = t.touches[0]), this.seekVideo(t));
  }
  seekVideo(t) {
    const s = this.timeline.getBoundingClientRect(),
      i = (t.clientX - s.left) / s.width;
    this.video.currentTime = i * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(t) {
    t.forEach((t) => {
      if (t.isIntersecting) {
        for (let t of this.video.querySelectorAll("source[data-src]"))
          t.setAttribute("src", t.getAttribute("data-src")), t.removeAttribute("data-src");
        this.video.load();
        var i = this.video.play();
        void 0 !== i &&
          i["catch"]((t) => {
            t.name === "NotAllowedError" &&
              (this.classList.remove("internal-video--playing"),
              this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible"));
          }).then(() => {
            this.video.play();
          }),
          this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(),
      (this.sliderOverlay = this.querySelector(".comparison-slider__overlay")),
      (this.sliderLine = this.querySelector(".comparison-slider__line")),
      (this.sliderInput = this.querySelector(".comparison-slider__input")),
      this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(t) {
    const s = t.currentTarget.value;
    (this.sliderOverlay.style.width = s + "%"), (this.sliderLine.style.left = s + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.testMode = this.dataset.testMode === "true"),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector(".sign-up-popup-modal")),
      (this.timer = this.querySelector(".popup-modal__timer")),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll(".promp-popup__close-btn")),
      (this.overlay = document.querySelector(".sign-up-popup-overlay")),
      (this.storageKey = "promo-bar-data-" + window.location.host),
      this.testMode)
    )
      this.timer && this.displayPromoTimer();
    else if (null === localStorage.getItem(this.storageKey)) this.openPopupModal();
    else {
      const e = JSON.parse(localStorage.getItem(this.storageKey)),
        s = new Date(e.next_display_date);
      currentDate.getTime() > s.getTime() && this.openPopupModal();
    }
    this.closeBtns.forEach((e) => {
      e.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
        const e = { next_display_date: addDays(currentDate, parseInt(this.daysFrequency)), dismissed: !1 };
        localStorage.setItem(this.storageKey, JSON.stringify(e)), this.timer && this.displayPromoTimer();
      },
      1e3 * parseInt(this.secondsDelay) + 3e3,
    );
  }
  displayPromoTimer() {
    (this.minutesSpan = this.querySelector(".popup-modal__timer__minutes")),
      (this.secondsSpan = this.querySelector(".popup-modal__timer__seconds")),
      (this.totalSeconds = 60 * parseFloat(this.timerDuration)),
      this.updateTimer();
    setInterval(() => {
      (this.totalSeconds -= 1),
        this.updateTimer(),
        this.totalSeconds <= 0 && (this.totalSeconds = 60 * parseFloat(this.timerDuration) - 45);
    }, 1e3);
  }
  updateTimer() {
    let e = Math.floor(this.totalSeconds / 60);
    1 === e.toString().length && (e = "0" + e);
    let s = this.totalSeconds % 60;
    1 === s.toString().length && (s = "0" + s), (this.minutesSpan.innerText = e), (this.secondsSpan.innerText = s);
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(),
      (this.sectionOneContainer = this.querySelector(".section-group__section-one-container")),
      (this.sectionTwoContainer = this.querySelector(".section-group__section-two-container")),
      this.transferSections(),
      document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    (this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping")),
      (this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping")),
      this.sectionOne &&
        !this.sectionOneContainer.childNodes.length &&
        this.sectionOneContainer.appendChild(this.sectionOne),
      this.sectionTwo &&
        !this.sectionTwoContainer.childNodes.length &&
        this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(),
      (this.button = this.querySelector(".clickable-discount__btn")),
      this.button.addEventListener("click", this.handleClick.bind(this)),
      this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    (this.dataset.loading = "true"),
      (this.button.disabled = true),
      (this.dataset.error = "false"),
      fetch("/discount/" + this.dataset.code)
        .then((e) => {
          if (!e.ok) throw new Error("Error");
          (this.dataset.applied = "true"), sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
        })
        ["catch"]((e) => {
          (this.dataset.error = "true"), (this.button.disabled = !1);
        })
        ["finally"](() => {
          this.dataset.loading = "false";
        });
  }
  reapplyDiscountIfApplicable() {
    const e = this.dataset.code;
    sessionStorage.getItem("discount-" + e + "-applied") &&
      ((this.dataset.applied = "true"),
      (this.button.disabled = true),
      setTimeout(() => {
        fetch("/discount/" + e)["catch"]((t) => {
          (this.dataset.applied = "false"), (this.button.disabled = !1);
        });
      }, 3e3));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(","))),
      (this.months = this.dataset.monthLabels.split(",")),
      (this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]')),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener("shopify:section:load", (e) => {
        this.insertDates();
      });
  }
  insertDates() {
    this.elementsToChange.forEach((e) => {
      const s = null,
        i = e.dataset.text,
        a = parseInt(e.dataset.minDays),
        n = parseInt(e.dataset.maxDays),
        c = addDays(currentDate, a);
      let r = "th";
      const o = c.getDate();
      1 === o || 21 === o || 31 === o
        ? (r = "st")
        : 2 === o || 22 === o
          ? (r = "nd")
          : (3 !== o && 23 !== o) || (r = "rd");
      const h = addDays(currentDate, n);
      let l = "th";
      const d = h.getDate();
      let u, f;
      if (
        (1 === d || 21 === d || 31 === d
          ? (l = "st")
          : 2 === d || 22 === d
            ? (l = "nd")
            : (3 !== d && 23 !== d) || (l = "rd"),
        this.dateFormat === "day_dd_mm")
      )
        (u = this.days[c.getDay()] + ", " + c.getDate() + ". " + this.months[c.getMonth()]),
          (f = this.days[h.getDay()] + ", " + h.getDate() + ". " + this.months[h.getMonth()]);
      else if (this.dateFormat === "mm_dd")
        (u = this.months[c.getMonth()] + " " + c.getDate() + r),
          (f = this.months[h.getMonth()] + " " + h.getDate() + l);
      else if (this.dateFormat === "dd_mm")
        (u = c.getDate() + ". " + this.months[c.getMonth()]), (f = h.getDate() + ". " + this.months[h.getMonth()]);
      else if (this.dateFormat === "dd_mm_no_dot")
        (u = c.getDate() + " " + this.months[c.getMonth()]), (f = h.getDate() + " " + this.months[h.getMonth()]);
      else if ("day_dd_mm_numeric" === this.dateFormat) {
        const t = String(c.getDate()).length > 1 ? c.getDate() : "0" + c.getDate(),
          e = String(c.getMonth() + 1).length > 1 ? c.getMonth() + 1 : "0" + (c.getMonth() + 1);
        u = this.days[c.getDay()] + ", " + t + ". " + e + ".";
        const i = String(h.getDate()).length > 1 ? h.getDate() : "0" + h.getDate(),
          a = String(h.getMonth() + 1).length > 1 ? h.getMonth() + 1 : "0" + (h.getMonth() + 1);
        f = this.days[h.getDay()] + ", " + i + ". " + a + ".";
      } else if ("dd_mm_numeric" === this.dateFormat) {
        u =
          (String(c.getDate()).length > 1 ? c.getDate() : "0" + c.getDate()) +
          ". " +
          (String(c.getMonth() + 1).length > 1 ? c.getMonth() + 1 : "0" + (c.getMonth() + 1)) +
          ".";
        f =
          (String(h.getDate()).length > 1 ? h.getDate() : "0" + h.getDate()) +
          ". " +
          (String(h.getMonth() + 1).length > 1 ? h.getMonth() + 1 : "0" + (h.getMonth() + 1)) +
          ".";
      } else
        (u = this.days[c.getDay()] + ", " + this.months[c.getMonth()] + " " + c.getDate() + r),
          (f = this.days[h.getDay()] + ", " + this.months[h.getMonth()] + " " + h.getDate() + l);
      const p = i.replace("[start_date]", u).replace("[end_date]", f);
      e.innerHTML = p;
    });
  }
  rearrangeDays(t) {
    return t.unshift(t[6]), (t.length = 7), t;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(),
      (this.isAfterScroll = this.dataset.afterScroll === "true"),
      (this.isScrollBtn = this.dataset.scrollBtn === "true"),
      (this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section)),
      (this.floatingBtns = document.querySelectorAll(".floating-btn")),
      this.footerSpacing(),
      this.isAfterScroll
        ? this.mainAtcBtn &&
          (this.checkATCScroll(), document.addEventListener("scroll", this.checkATCScroll.bind(this)))
        : this.floatingBtns.forEach((e) => {
            e.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
          }),
      this.isScrollBtn &&
        ((this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn")),
        (this.scrollDestination = document.querySelector(
          "" + this.dataset.scrollDestination.replace("id", this.dataset.section),
        )),
        this.scrollBtn &&
          this.scrollDestination &&
          this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this)));
  }
  checkATCScroll() {
    window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = "none"), (this.scrolledPast = true))
      : ((this.style.transform = ""), (this.scrolledPast = !1)),
      this.floatingBtns.forEach((e) => {
        this.scrolledPast
          ? e.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px")
          : e.style.setProperty("--sticky-atc-offset", "0px");
      });
  }
  handleScrollBtn() {
    const e = document.querySelector("sticky-header"),
      s = e ? e.clientHeight : 0;
    window.scrollTo({ top: this.scrollDestination.offsetTop - s - 15, behavior: "smooth" });
  }
  footerSpacing() {
    let e = document.querySelector(".sticky-atc-footer-spacer");
    if (e) return;
    (e = document.createElement("div")),
      (e.className = "sticky-atc-footer-spacer"),
      (e.style.height = this.clientHeight - 1 + "px"),
      (e.style.display = "block");
    const s = document.querySelector(".footer");
    s && (e.style.background = window.getComputedStyle(s).background), document.body.appendChild(e);
  }
}
customElements.define("sticky-atc", StickyAtc),
  (function () {
    if (!formatDates(currentDate, date)) {
      window.location.hostname.includes("shopify") ||
        (document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm") &&
          (document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm").isCartUpsell = true));
    }
  })();
class BundleDeals extends HTMLElement {
  constructor() {
    super(),
      (this.productContainers = this.querySelectorAll(".bundle-deals__product-js")),
      (this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js")),
      (this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js")),
      (this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js")),
      (this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js")),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.prices = this.querySelectorAll(".bundle-deals__price-js")),
      (this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js")),
      (this.totalPrice = this.querySelector(".bundle-deals__total-price-js")),
      (this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.currencySymbol = this.dataset.currencySymbol),
      (this.selectedVariants = { id_1: null, id_2: null, id_3: null, id_4: null, id_5: null }),
      (this.formVariants = []),
      this.initIds(),
      this.checkboxes.forEach((e) => {
        e.addEventListener("change", this.handleCheckboxChange.bind(this));
      }),
      this.variantPickers.forEach((e) => {
        e.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  initIds() {
    this.checkboxes.forEach((e) => {
      this.selectedVariants[e.dataset.idIndex] = {
        id: e.dataset.id,
        price: e.dataset.price,
        comparePrice: e.dataset.comparePrice,
        checked: true,
      };
    }),
      this.updateFormIds();
  }
  handleCheckboxChange(t) {
    const s = t.currentTarget,
      i = s.checked,
      a = parseInt(s.dataset.index);
    this.selectedVariants[s.dataset.idIndex].checked = i;
    const n = this.productContainers[a],
      c = n.querySelectorAll("select");
    i
      ? (this.mediaItemContainers[a].classList.remove("bundle-deals__media-item--disabled"),
        n.classList.remove("bundle-deals__product--deselected"),
        c.forEach((t) => {
          t.removeAttribute("disabled");
        }))
      : (this.mediaItemContainers[a].classList.add("bundle-deals__media-item--disabled"),
        n.classList.add("bundle-deals__product--deselected"),
        c.forEach((t) => {
          t.setAttribute("disabled", "");
        })),
      this.updateFormIds(),
      this.updatePrices && this.updateTotalPrice();
  }
  handleSelectChange(t) {
    const s = t.currentTarget,
      i = parseInt(s.dataset.index),
      a = Array.from(s.querySelectorAll("select"), (t) => t.value);
    updateVariantStatuses(
      JSON.parse(s.querySelector('[type="application/json"]').textContent).filter(
        (t) => s.querySelector(":checked").value === t.option1,
      ),
      [...s.querySelectorAll(".select--small")],
    );
    const n = JSON.parse(s.querySelector('[type="application/json"]').textContent).find((t) => {
      return !t.options.map((t, e) => a[e] === t).includes(!1);
    });
    if (!n) return void (this.skipNonExistent && findAvailableVariant(s, a, !1, true, this.skipUnavailable));
    if (this.skipUnavailable && !n.available && findAvailableVariant(s, a, !1, true, true)) return;
    let { price: c, compare_at_price: r, featured_image: o } = n;
    c = parseInt(c);
    let h = r ? parseInt(r) : c;
    (c = c * (s.dataset.percentageLeft ?? 1) - (s.dataset.fixedDiscount ?? 0)), o && (o = o.src);
    const l = n.id;
    (this.selectedVariants[s.dataset.idIndex].id = l),
      (this.selectedVariants[s.dataset.idIndex].price = c),
      (this.selectedVariants[s.dataset.idIndex].comparePrice = h),
      this.updateFormIds(),
      this.updatePrices &&
        ((this.prices[i].innerHTML = this.currencySymbol + (c / 100).toFixed(2)),
        h > c
          ? (this.comparePrices[i].innerHTML = this.currencySymbol + (h / 100).toFixed(2))
          : (this.comparePrices[i].innerHTML = ""),
        this.updateTotalPrice()),
      o && o.length > 0 && this.mediaItemImgs[i] && (this.mediaItemImgs[i].src = o);
  }
  updateFormIds() {
    const e = [],
      s = this.selectedVariants;
    for (const i in s) {
      const a = s[i];
      if (null != a && a.checked) {
        const s = e.findIndex((t) => t.id === a.id);
        s < 0 ? e.unshift({ id: a.id, quantity: 1 }) : (e[s].quantity += 1);
      }
    }
    this.formVariants = e;
  }
  updateTotalPrice() {
    const e = [],
      s = [],
      i = this.selectedVariants;
    for (const a in i) {
      const n = i[a];
      null != n && n.checked && (e.push(parseInt(n.price)), s.push(parseInt(n.comparePrice)));
    }
    const a = e.reduce((t, e) => t + e, 0) * this.percentageLeft - this.fixedDiscount,
      n = s.reduce((t, e) => t + e, 0);
    (this.totalPrice.innerHTML = this.currencySymbol + (a / 100).toFixed(2)),
      n > a
        ? (this.totalComparePrice.innerHTML = this.currencySymbol + (n / 100).toFixed(2))
        : (this.totalComparePrice.innerHTML = "");
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(),
      (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
      (this.inputs = this.querySelectorAll('input[name="quantity"]')),
      (this.labels = this.querySelectorAll(".quantity-break")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.hasVariants = this.jsonData.dataset.hasVariants === "true"),
      (this.selectedVariants = { input_1: [], input_2: [], input_3: [], input_4: [], input_5: [], input_6: [] }),
      (this.updateUnavailable = this.dataset.updateUnavailable === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.formVariants = []),
      (this.selectedQuantity = 1),
      this.querySelector("input[checked]") &&
        (this.selectedQuantity = parseInt(this.querySelector("input[checked]").value)),
      (this.variantSelects = this.querySelectorAll(".quantity-break__selector-item")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.moneyFormat = this.dataset.moneyFormat),
      this.hasVariants && this.initVariants(),
      this.inputs.forEach((e) => {
        e.addEventListener("change", this.handleChange.bind(this));
      }),
      this.variantSelects.forEach((e) => {
        e.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  handleSelectChange(t) {
    const s = t.currentTarget,
      i = Array.from(s.querySelectorAll("select"), (t) => t.value);
    if (this.updateUnavailable) {
      updateVariantStatuses(
        this.getVariantData().filter((t) => s.querySelector(":checked").value === t.option1),
        [...s.querySelectorAll(".select--small")],
      );
    }
    const a = this.getVariantData().find((t) => {
      return !t.options.map((t, e) => i[e] === t).includes(!1);
    });
    if (!a) return void (this.skipNonExistent && findAvailableVariant(s, i, !1, true, this.skipUnavailable));
    if (this.skipUnavailable && !a.available && findAvailableVariant(s, i, !1, true, true)) return;
    s.dataset.selectedId = a.id;
    const n = s.dataset.selectIndex,
      c = s.closest(".quantity-break"),
      r = c.dataset.input;
    if (
      ((this.selectedVariants[r][n] = a.id),
      (this.formVariants = this.selectedVariants[r]),
      this.updateMedia(a),
      !this.updatePrices)
    )
      return;
    var o = 0,
      h = 0;
    const l = parseFloat(c.dataset.quantity),
      d = parseFloat(c.dataset.percentageLeft),
      u = parseFloat(c.dataset.fixedDiscount);
    for (let t = 0; t < l; t++) {
      const s = parseInt(this.selectedVariants[r][t]),
        i = this.getVariantData().find((t) => parseInt(t.id) === s);
      if (!i) return;
      (o += i.price), i.compare_at_price && i.compare_at_price > i.price ? (h += i.compare_at_price) : (h += i.price);
    }
    const f = h - (o = o * d - u),
      p = 100 * Math.round(f / 100),
      m = o / l,
      _ = h / l,
      x = formatMoney(o, this.moneyFormat, true),
      I = formatMoney(h, this.moneyFormat, true),
      y = formatMoney(f, this.moneyFormat, true),
      g = formatMoney(p, this.moneyFormat, true),
      v = formatMoney(m, this.moneyFormat, true),
      S = formatMoney(_, this.moneyFormat, true);
    c.querySelectorAll(".variant-price-update").forEach((t) => {
      let i = t.dataset.text;
      (i = i.replace("[quantity]", l)),
        (i = i.replace("[price]", x)),
        (i = i.replace("[compare_price]", I)),
        (i = i.replace("[amount_saved]", y)),
        (i = i.replace("[amount_saved_rounded]", g)),
        (i = i.replace("[price_each]", v)),
        (i = i.replace("[compare_price_each]", S)),
        (t.innerHTML = i);
    });
    const b = c.querySelector(".quantity-break__compare-price");
    b && (h > o ? b.classList.remove("hidden") : b.classList.add("hidden"));
  }
  getVariantData() {
    return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
  }
  initVariants() {
    this.hasVariants &&
      (this.labels.forEach((e) => {
        const s = null;
        if (e.querySelector(".quantity-break__variants")) {
          let t = [];
          e.querySelectorAll(".quantity-break__selector-item").forEach((e) => {
            t.push(e.dataset.selectedId);
          }),
            (this.selectedVariants[e.dataset.input] = t);
        }
      }),
      (this.formVariants = []));
  }
  updateMedia(t) {
    if (!t) return;
    if (!t.featured_media) return;
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((s) => s.setActiveMedia(this.dataset.section + "-" + t.featured_media.id, true));
  }
  handleChange(t) {
    const s = parseInt(t.target.value);
    (this.selectedQuantity = s),
      this.hasVariants && (this.formVariants = this.selectedVariants[t.target.dataset.input]),
      this.quantityGifts && this.quantityGifts.unlockGifts(s);
  }
}
function updateVariantStatuses(t, e) {
  e.forEach((i, a) => {
    if (0 === a) return;
    const c = [...i.querySelectorAll("option")],
      r = e[a - 1].querySelector(":checked").value,
      o = t.filter((t) => t.available && t["option" + a] === r).map((t) => t["option" + (a + 1)]),
      h = t.filter((t) => t["option" + a] === r).map((t) => t["option" + (a + 1)]);
    c.forEach((t) => {
      t.classList.remove("unavailable", "non-existent"),
        h.includes(t.getAttribute("value"))
          ? o.includes(t.getAttribute("value"))
            ? (t.innerText = t.getAttribute("value"))
            : ((t.innerText = window.variantStrings.unavailable_with_option.replace(
                "[value]",
                t.getAttribute("value"),
              )),
              t.classList.add("unavailable"))
          : ((t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", t.getAttribute("value"))),
            t.classList.add("non-existent"));
    });
  });
}
function findAvailableVariant(t, e, s = true, i = !1, a = !1) {
  console.log("Running findAvailableVariant");
  for (let c = e.length - 1; c >= 0; c--) {
    const r = s ? t.querySelector(".product-form__input:nth-child(" + (c + 1) + ")") : t.querySelectorAll(".select")[c],
      o = s ? r.querySelector(".product-form__input__type").dataset.type : "dropdown",
      h = o === "dropdown" ? r.querySelectorAll("option") : r.querySelectorAll('input[type="radio"]');
    let l = Array.from(h).findIndex((t) => t.value === e[c]),
      d = !1;
    for (; l < h.length - 1; ) {
      l++;
      const t = h[l];
      if (!((i && t.classList.contains("non-existent")) || (a && t.classList.contains("unavailable")))) {
        (e[c] = t.value), (d = true);
        break;
      }
    }
    if (!d)
      for (l = Array.from(h).findIndex((t) => t.value === e[c]); l > 0; ) {
        l--;
        const t = h[l];
        if (!((i && t.classList.contains("non-existent")) || (a && t.classList.contains("unavailable")))) {
          (e[c] = t.value), (d = true);
          break;
        }
      }
    if (d)
      return (
        o === "dropdown"
          ? (r.querySelector(".select__select").value = e[c])
          : (r.querySelector('input[type="radio"][value="' + e[c] + '"]').checked = true),
        t.dispatchEvent(new Event("change")),
        true
      );
  }
  return !1;
}
customElements.define("quantity-breaks", QuantityBreaks);
class QuantityGifts extends HTMLElement {
  constructor() {
    super(),
      (this.gifts = this.querySelectorAll(".quantity-gift")),
      (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
      (this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section)),
      (this.unlockedItems = []),
      this.initUnlock();
  }
  initUnlock() {
    let e = 1;
    if (this.quantityBreaks) e = parseInt(this.quantityBreaks.selectedQuantity);
    else if (this.quantitySelector) {
      const s = this.quantitySelector.querySelector('input[name="quantity"]');
      e = parseInt(s.value);
    }
    this.unlockGifts(e);
  }
  unlockGifts(t) {
    (this.unlockedItems = []),
      this.gifts.forEach((s) => {
        parseInt(s.dataset.quantity) <= t
          ? (s.classList.add("quantity-gift--unlocked"),
            (s.dataset.unlocked = "true"),
            this.unlockedItems.unshift(s.dataset.product))
          : (s.classList.remove("quantity-gift--unlocked"), (s.dataset.unlocked = "false"));
      });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.image = this.querySelector(".upsell__image__img")),
      (this.toggleBtn = this.querySelector(".upsell-toggle-btn")),
      (this.variantSelects = this.querySelector(".upsell__variant-picker")),
      (this.variantSelectElements = this.querySelectorAll(".select__select")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector(".upsell__price .regular-price")),
        (this.comparePriceSpan = this.querySelector(".upsell__price .compare-price")),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat),
        (this.isMainOfferItem = this.dataset.mainOfferItem === "true"),
        this.isMainOfferItem &&
          (this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section))),
      this.toggleBtn && this.toggleBtn.addEventListener("click", this.handleToggle.bind(this)),
      this.variantSelects && this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(t) {
    t.target.nodeName.toLowerCase() !== "select" &&
      "option" !== t.target.nodeName.toLowerCase() &&
      (this.dataset.selected === "true" ? (this.dataset.selected = "false") : (this.dataset.selected = "true"));
  }
  handleSelectChange(t) {
    const s = t.currentTarget,
      i = Array.from(s.querySelectorAll("select"), (t) => t.value),
      a = this.getVariantData().find((t) => {
        return !t.options.map((t, e) => i[e] === t).includes(!1);
      });
    updateVariantStatuses(
      this.getVariantData().filter((t) => s.querySelector(":checked").value === t.option1),
      [...s.querySelectorAll("select")],
    ),
      a
        ? (this.skipUnavailable && !a.available && findAvailableVariant(s, i, !1, true, true)) ||
          (this.updatePrices &&
            ((this.price = a.price * this.percentageLeft - this.fixedDiscount),
            (this.comparePrice = a.price),
            a.compare_at_price && a.compare_at_price > a.price && (this.comparePrice = a.compare_at_price),
            displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat)),
          this.image && a.featured_image && (this.image.src = a.featured_image.src),
          this.updateId(a.id),
          this.isMainOfferItem &&
            this.mainOfferContainer.updateTotalPrices &&
            this.mainOfferContainer.updateTotalPrices())
        : this.skipNonExistent && findAvailableVariant(s, i, !1, true, this.skipUnavailable);
  }
  updateId(t) {
    this.dataset.id = t;
  }
  getVariantData() {
    return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.cartItems = this.cartDrawer.querySelector("cart-drawer-items")),
      (this.productForm = this.querySelector("product-form")),
      (this.idInput = this.productForm.querySelector('[name="id"]')),
      (this.classicAddButton = this.querySelector(".upsell__add-btn"));
  }
  handleToggle(t) {
    "select" !== t.target.nodeName.toLowerCase() &&
      "option" !== t.target.nodeName.toLowerCase() &&
      (this.dataset.selected === "true"
        ? ((this.dataset.selected = "false"), this.removeFromCart())
        : ((this.dataset.selected = "true"), this.addToCart()));
  }
  addRemoveFromCart() {
    this.dataset.selected !== "true" || this.cartDrawer.classList.contains("is-empty")
      ? this.removeFromCart()
      : this.addToCart();
  }
  addToCart() {
    this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle) ||
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((e) => {
        e.setAttribute("disabled", "");
      }),
      this.productForm.handleSubmit());
  }
  removeFromCart() {
    const e = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    e &&
      this.cartItems &&
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((e) => {
        e.setAttribute("disabled", "");
      }),
      this.cartItems.updateQuantity(e.dataset.index, 0));
  }
  updateId(t) {
    if (((this.dataset.id = t), (this.idInput.value = t), !this.classicAddButton && this.dataset.selected === "true")) {
      this.selectTimeout && clearTimeout(this.selectTimeout), this.removeFromCart();
      const t = (s) => {
        s.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", t));
      };
      document.addEventListener("cartQuantityUpdated", t);
    }
  }
  getUpdateRequired() {
    const e = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let s = !1;
    return ((e && "false" === this.dataset.selected) || (!e && this.dataset.selected === "true")) && (s = true), s;
  }
}
function displayPrices(t, e, s, i, a) {
  if (a) {
    if (t && s) {
      var c = formatMoney(t, a);
      s.innerHTML = c;
    }
    if (e && i) {
      var r = formatMoney(e, a);
      (i.innerHTML = r), e > t ? i.classList.remove("hidden") : i.classList.add("hidden");
    }
  }
}
function formatMoney(t, e, s = !1) {
  "string" == typeof t && (t = t.replace(".", ""));
  var a = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    c = e;
  function r(t, e) {
    return void 0 === t ? e : t;
  }
  function o(t, e, a, n) {
    if (((e = r(e, 2)), (a = r(a, ",")), (n = r(n, ".")), isNaN(t) || null == t)) return 0;
    var o = (t = (t / 100).toFixed(e)).split("."),
      h = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a),
      l = o[1] ? n + o[1] : "";
    return s && l === n + "00" && (l = ""), h + l;
  }
  switch (c.match(n)[1]) {
    case "amount":
      a = o(t, 2);
      break;
    case "amount_no_decimals":
      a = o(t, 0);
      break;
    case "amount_with_comma_separator":
      a = o(t, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      a = o(t, 0, ".", ",");
  }
  return c.replace(n, a);
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
function initToggleUpsells() {
  const e = document.querySelector("cart-drawer");
  e &&
    e.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((e) => {
      e.addRemoveFromCart && e.addRemoveFromCart();
    });
}
customElements.define("cart-drawer-gift", CartDrawerGift), initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(),
      (this.offerItems = this.querySelectorAll(".main-offer-item")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.priceSpan = this.querySelector(".bundle-deals__total-price-js")),
        (this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js")),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat));
  }
  updateTotalPrices() {
    if (this.updatePrices) {
      var e = 0,
        s = 0;
      for (let i = 0; i < this.offerItems.length; i++)
        (e += parseInt(this.offerItems[i].price)), (s += parseInt(this.offerItems[i].comparePrice));
      displayPrices(
        (e = e * this.percentageLeft - this.fixedDiscount),
        s,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      );
    }
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.fieldName = this.dataset.name),
      (this.input = this.querySelector('[type="text"], [type="number"], textarea')),
      (this.inputRadios = this.querySelectorAll('[type="radio"]')),
      (this.select = this.querySelector(".select__select")),
      (this.productForm = document.getElementById("product-form-" + this.dataset.section)),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === "true"),
      (this.isText = true),
      (this.notMain = "true" === this.dataset.notMain),
      (this.dataset.type !== "select" && this.dataset.type !== "pills") || (this.isText = !1),
      this.createInputs(),
      this.isRequired &&
        this.isText &&
        ((this.isValid = true),
        (this.atcButtons = this.notMain
          ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section)
          : document.querySelectorAll(".main-product-atc")),
        (this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section)),
        (this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label")),
        (this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error")),
        (this.atcErrorMsg = this.dataset.atcErrorMsg),
        (this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
        (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
        (this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true"),
        (this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section)),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label")),
          (this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error")),
          (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
        this.validateValue(this.prevValue, null)),
      this.input && this.input.addEventListener("input", this.handleChange.bind(this)),
      this.inputRadios.forEach((e) => {
        e.addEventListener("input", this.handleChange.bind(this));
      }),
      this.select && this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(t) {
    const s = t.target.value.trim();
    t.target.checkValidity()
      ? ((this.prevValue = s),
        (this.dataset.value = s),
        (this.productFormInput.value = s),
        this.isRequired && this.isText && this.validateValue(s, t.target))
      : (t.target.value = this.prevValue);
  }
  validateValue(t, e) {
    const i = t.length > 0 && true;
    if (i === this.isValid) return;
    (this.isValid = i),
      e &&
        (this.isValid
          ? (e.classList.remove("input--error"),
            (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1))
          : (e.classList.add("input--error"),
            (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1)));
    const a = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      n = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((t) => {
      a && !n ? t.removeAttribute("disabled") : t.setAttribute("disabled", "");
    }),
      0 !== this.atcErrorMsg.length &&
        (a
          ? ((this.mainAtcBtnLabel.style.display = ""),
            (this.mainAtcBtnError.style.display = "none"),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = ""), (this.stickyAtcBtnError.style.display = "none")))
          : ((this.mainAtcBtnLabel.style.display = "none"),
            (this.mainAtcBtnError.style.display = ""),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = "none"), (this.stickyAtcBtnError.style.display = ""))));
  }
  createInputs() {
    (this.productFormInput = document.createElement("input")),
      this.productFormInput.setAttribute("type", "hidden"),
      this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      (this.secondarySelectSelector = "StickyAtcVariantPicker-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = !1),
      (this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
      (this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true"),
      (this.prependMedia = this.dataset.disablePrepend != "true"),
      (this.filtering = this.dataset.hasFiltering === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    if (
      (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses(),
      this.currentVariant)
    ) {
      if (
        this.skipUnavailable &&
        !this.currentVariant.available &&
        findAvailableVariant(this, this.options, true, true, true)
      )
        return;
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    } else {
      if (
        (this.toggleAddButton(true, "", true),
        this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable))
      )
        return;
      this.setUnavailable();
    }
  }
  updateOptions() {
    const e = [];
    this.querySelectorAll(".product-form__input").forEach((s) => {
      let a;
      const n = s.querySelector(".product-form__input__type").dataset.type;
      (a =
        "dropdown" == n || n == "dropdwon"
          ? s.querySelector(".select__select").value
          : s.querySelector('input[type="radio"]:checked').value),
        e.push(a);
    }),
      (this.options = e);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((e) => {
      return !e.options.map((t, e) => this.options[e] === t).includes(!1);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    document
      .querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]')
      .forEach((e) =>
        e.setActiveMedia(
          this.dataset.section + "-" + this.currentVariant.featured_media.id,
          this.prependMedia,
          this.filtering,
          this.currentVariant,
        ),
      );
    const e = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!e) return;
    const s = e.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
    e.prepend(s);
  }
  updateURL() {
    this.currentVariant &&
      this.dataset.updateUrl !== "false" &&
      window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const e = document.getElementById("Share-" + this.dataset.section);
    e && e.updateUrl && e.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    document
      .querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section)
      .forEach((e) => {
        const i = e.querySelector('input[name="id"]');
        (i.value = this.currentVariant.id), i.dispatchEvent(new Event("change", { bubbles: true }));
      });
  }
  updateVariantStatuses() {
    const e = this.variantData.filter((e) => this.querySelector(":checked").value === e.option1);
    let s;
    (s =
      this.isSecondary && this.secondarySelect
        ? [...this.secondarySelect.querySelectorAll(".product-form__input")]
        : [...this.querySelectorAll(".product-form__input")]),
      s.forEach((i, a) => {
        if (0 === a) return;
        const c = [...i.querySelectorAll('input[type="radio"], .select__select option')],
          r = s[a - 1].querySelector(":checked").value,
          o = e.filter((t) => t.available && t["option" + a] === r).map((t) => t["option" + (a + 1)]),
          h = e.filter((t) => t["option" + a] === r).map((t) => t["option" + (a + 1)]);
        this.setInputAvailability(c, o, h);
      });
  }
  setInputAvailability(t, e, s) {
    t.forEach((t) => {
      t.classList.remove("unavailable", "non-existent", "disabled");
      const a = t.getAttribute("value");
      let n = null;
      t.dataset.swatch === "true" && (n = t.closest(".color-swatch")),
        n && n.classList.remove("unavailable", "non-existent", "disabled"),
        s.includes(a)
          ? e.includes(a)
            ? t.nodeName === "OPTION"
              ? (t.innerText = a)
              : (t.classList.remove("disabled"), n && n.classList.remove("disabled"))
            : t.nodeName === "OPTION"
              ? ((t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", a)),
                t.classList.add("unavailable"))
              : (t.classList.add("disabled", "unavailable"), n && n.classList.add("disabled", "unavailable"))
          : t.nodeName === "OPTION"
            ? ((t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", a)),
              t.classList.add("non-existent"))
            : (t.classList.add("disabled", "non-existent"), n && n.classList.add("disabled", "non-existent"));
    });
  }
  updatePickupAvailability() {
    const e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability && e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  removeErrorMessage() {
    const e = this.closest("section");
    if (!e) return;
    const s = e.querySelector("product-form");
    s && s.handleErrorMessage();
  }
  renderProductInfo() {
    const e = this.currentVariant.id,
      s = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        e +
        "&section_id=" +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
    )
      .then((e) => e.text())
      .then((i) => {
        const a = null;
        if (this.currentVariant.id !== e) return;
        const n = new DOMParser().parseFromString(i, "text/html"),
          c = document.getElementById("price-" + this.dataset.section),
          r = n.getElementById(
            "price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          o = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
          h = n.getElementById(
            "sticky-atc-separate-price-" +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          l = document.getElementById("sticky-atc-price-" + this.dataset.section),
          d = n.getElementById(
            "sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          u = document.getElementById("sticky-atc-image-" + this.dataset.section),
          f = n.getElementById(
            "sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          p = document.getElementById("main-atc-price-" + this.dataset.section),
          m = n.getElementById(
            "main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _ = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]'),
          x = n.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
              '"]',
          ),
          I = n.getElementById(
            "Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          y = document.getElementById("Sku-" + this.dataset.section),
          g = n.getElementById(
            "Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          v = document.getElementById("Inventory-" + this.dataset.section);
        if (
          (c && r && (c.innerHTML = r.innerHTML),
          o && h && (o.innerHTML = h.innerHTML),
          l && d && (l.innerHTML = d.innerHTML),
          u && f && (u.src = f.src),
          m && p && (p.innerHTML = m.innerHTML),
          _ && x)
        )
          for (var S = 0; S < _.length; S++) _[S].innerHTML = x[S].innerHTML;
        if (
          (g && v && (v.innerHTML = g.innerHTML),
          I &&
            y &&
            ((y.innerHTML = I.innerHTML),
            y.classList.toggle("visibility-hidden", I.classList.contains("visibility-hidden"))),
          this.QuantityBreaks)
        ) {
          const t = n.getElementById(
              "quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
            ),
            e = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
            s = t.querySelectorAll(".dynamic-price");
          for (let t = 0; t < e.length; t++) e[t].innerHTML = s[t].innerHTML;
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((t) => {
              t.dataset.selectedId = this.currentVariant.id;
            });
            const e = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
              s = t.querySelectorAll(".quantity-break__variant-select");
            for (let t = 0; t < e.length; t++) e[t].innerHTML = s[t].innerHTML;
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const t = n.getElementById(
              "variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
            ),
            e = this.querySelectorAll(".dynamic-price"),
            s = t.querySelectorAll(".dynamic-price");
          for (let t = 0; t < e.length; t++) e[t].innerHTML = s[t].innerHTML;
          if (
            "vertical" === this.quantityBreaksPickerStyle &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const e = this.querySelectorAll(".quantity-break__image img"),
              s = t.querySelectorAll(".quantity-break__image img");
            for (let t = 0; t < e.length; t++) e[t].src = s[t].src;
          }
        }
        if (this.secondarySelect) {
          const t = n.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          t && (this.secondarySelect.innerHTML = t.innerHTML);
        }
        const b = document.getElementById("price-" + this.dataset.section);
        b && b.classList.remove("visibility-hidden"), v && v.classList.toggle("visibility-hidden", "" === g.innerText);
        const E = n.getElementById("ProductSubmitButton-" + s);
        this.toggleAddButton(E ? E.hasAttribute("disabled") : true, window.variantStrings.soldOut),
          publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: s, html: n, variant: this.currentVariant } });
      });
  }
  toggleAddButton(t = true, e, s = true) {
    const a = document.getElementById("product-form-" + this.dataset.section);
    if (!a) return;
    const n = a.querySelector('[name="add"]'),
      c = document.querySelectorAll(".main-product-atc");
    var r = a.querySelector(".main-atc__label__text");
    r || (r = a.querySelector(".main-atc__label"));
    const o = a.querySelector(".main-atc-price");
    n &&
      (t
        ? (n.setAttribute("disabled", "disabled"),
          n.setAttribute("data-unavailable", "true"),
          e && (r.textContent = e),
          c.forEach((t) => {
            t.setAttribute("disabled", "disabled");
          }),
          o && o.classList.add("hidden"))
        : (n.setAttribute("data-unavailable", "false"),
          (r.textContent = window.variantStrings.addToCart),
          o && o.classList.remove("hidden"),
          n.dataset.requiredFields === n.dataset.validFields &&
            (n.removeAttribute("disabled"),
            c.forEach((t) => {
              t.removeAttribute("disabled");
            }))));
  }
  setUnavailable() {
    const e = document.getElementById("product-form-" + this.dataset.section);
    if (!e) return;
    const s = e.querySelector('[name="add"]');
    var i = e.querySelector(".main-atc__label__text");
    i || (i = e.querySelector(".main-atc__label"));
    const a = document.getElementById("price-" + this.dataset.section),
      n = document.getElementById("Inventory-" + this.dataset.section),
      c = document.getElementById("Sku-" + this.dataset.section);
    s &&
      ((i.textContent = window.variantStrings.unavailable),
      a && a.classList.add("visibility-hidden"),
      n && n.classList.add("visibility-hidden"),
      c && c.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = true);
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = true);
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), (this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit"));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, "", !1),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateVariantInput(),
          this.updateQuickAddUrl(),
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut))
        : (this.toggleAddButton(true, "", true), this.setUnavailable());
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const e = document.getElementById(this.dataset.section + "-image");
    if (!e) return;
    const s = this.currentVariant.featured_media.preview_image,
      i = s.src.split("?")[0],
      a = [165, 360, 533, 720, 940, 1066]
        .filter((e) => s.width >= e)
        .map((e) => i + "?width=" + e + " " + e + "w")
        .join(", ");
    (e.srcset = a + ", " + i + " " + s.width + "w"), (e.src = i + "?width=533");
  }
  updateQuickAddUrl() {
    this.currentVariant &&
      this.quickAddSubmit &&
      (this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id);
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
